import { render, staticRenderFns } from "./name.vue?vue&type=template&id=7b2299b2&scoped=true"
import script from "./name.vue?vue&type=script&setup=true&lang=js"
export * from "./name.vue?vue&type=script&setup=true&lang=js"
import style0 from "./name.vue?vue&type=style&index=0&id=7b2299b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2299b2",
  null
  
)

export default component.exports